export default __webpack_public_path__ + "static/media/lettering.8f10880a.jpg";